import { useState, useEffect } from 'react';
import { adminService } from '../../services/admin.service';
import { ContactMessage } from '../../types/admin.types';
import { RefreshCw, Mail, Trash2 } from 'lucide-react';
import '../../styles/admin.css';

export function AdminMessagesPage() {
  const [messages, setMessages] = useState<ContactMessage[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await adminService.getContactMessages();
      setMessages(data);
    } catch (err: any) {
      setError(err.message || 'Mesajlar yüklenirken hata oluştu.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Bu mesajı silmek istediğinize emin misiniz?')) return;
    try {
      await adminService.deleteContactMessage(id);
      setMessages((prev) => prev.filter((m) => m.id !== id));
    } catch (err: any) {
      alert(err.message || 'Silme işlemi başarısız.');
    }
  };

  const handleReply = (email: string) => {
    window.location.href = `mailto:${email}`;
  };

  if (isLoading) {
    return (
      <div className="admin-page-container">
        <h2>İletişim Mesajları</h2>
        <div>Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="admin-page-container">
      <div className="admin-page-header">
        <div>
          <h2 className="admin-page-title">İletişim Mesajları</h2>
          <p className="admin-page-subtitle">Landing sayfasından gönderilen form mesajlarını görüntüleyin ve yanıtlayın.</p>
        </div>
        <button className="btn-admin-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }} onClick={fetchMessages}>
          <RefreshCw size={14} /> Yenile
        </button>
      </div>

      {error && <div className="admin-error-message">{error}</div>}

      <div className="admin-card">
        {messages.length === 0 ? (
          <p style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '2rem' }}>
            Henüz hiç mesaj bulunmuyor.
          </p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Tarih</th>
                <th>Gönderen</th>
                <th>Rol</th>
                <th>Mesaj</th>
                <th style={{ textAlign: 'right' }}>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((msg) => (
                <tr key={msg.id}>
                  <td>{new Date(msg.created_at).toLocaleString('tr-TR')}</td>
                  <td>
                    <div>{msg.name}</div>
                    <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>{msg.email}</div>
                  </td>
                  <td>
                    <span className={`admin-badge ${msg.role === 'admin' ? 'badge-danger' : 'badge-primary'}`}>
                      {msg.role || 'Bilinmiyor'}
                    </span>
                  </td>
                  <td style={{ maxWidth: '300px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {msg.message}
                  </td>
                  <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button
                      className="btn-admin-outline"
                      style={{ marginRight: '0.5rem', display: 'inline-flex', alignItems: 'center', gap: 4 }}
                      onClick={() => handleReply(msg.email)}
                    >
                      <Mail size={12} /> Yanıtla
                    </button>
                    <button
                      className="btn-admin-danger"
                      style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
                      onClick={() => handleDelete(msg.id)}
                    >
                      <Trash2 size={12} /> Sil
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
